class VwKimlikDTO {
    id: number = 0;
    kimlikTurId?: number = 1;
    kimlikNo?: string = "";
    pasaportNo?: string = "";
    adi?: string = "";
    soyadi?: string = "";
    babaAdi?: string = "";
    anaAdi?: string = "";
    dogumYeri?: string = "";
    dogumTarihi?: string = null;
    postaKodu?: string = "";
    adres?: string = "";
    email?: string = "";
    yakinEmail?: string = "";
    fotograf?: string = "";
    proxyKartNo?: number = null;
    cinsiyetId?: number = null;
    medeniHalId?: number = null;
    kanGrupId?: number = null;
    meslekId?: number = null;
    ogrenimId?: number = null;
    uyrukId?: string = "";
    tel1?: string = "";
    tel2?: string = "";
    yakinTelefon?: string = "";
    olumTarihi?: string = null;
    hastaRumuz?: string = "";
    hastaRumuzLoginkod?: string = "";
    hastaRumuzSonlanmaTarihi?: string = null;
    hastaRumuzNedeni?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    seriNo?: string = "";
    aileAdi?: string = "";
    iletisimTercih?: string = "";
    yabanciTel?: string = "";
    adresIl?: number = null;
    adresIlce?: number = null;
}
export default VwKimlikDTO;